import Handler from "../Handler";

class TableEndedHandler extends Handler{
    //TableEnded#<no data> - received when the tourney table being watched is no longer available
    execute(message){
        this.service.processTableEnded();
    }
}

export default TableEndedHandler;